import React from 'react'
import { Header } from '../Header'
import Banner from '../Images/kpn-mobile-banner.png';
import Orange from '../Images/kpn-1.png';



export const Home = () => {
  return (
    <div className='home'>
        <Header />

        <div className="banner">

            <div className='banner-content'>
                <p>Fair price, great shopping experience</p>
                <h1>Welcome to Kovai Pazhamudir Nilayam</h1>
                <button className='banner-btn'>View More </button>
            </div>

            <div className='banner-img'>
                <img src={Banner} alt='bannerpic' />
            </div>

        </div>

    
<div className='orange'>
<img src={Orange} alt='bannerpic' />
</div>

    </div>
  )
}
